import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.invoice)?_c(VCard,{staticClass:"py-4"},[_c(VCardText,{staticClass:"pa-4 mt-n4"},[_c(VRow,{attrs:{"dense":""}},[_c(VCol,[_c('invoice-information',{ref:"clear_selected_products",on:{"set_selected_products":_vm.set_selected_products}})],1)],1)],1),_c('add-invoice-item')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }